import { useState } from "react";
import { Plus, X } from "lucide-react";

export default function TemplateManager({ templates, onInstantiate, onDelete, onCreate }) {
  const [showForm, setShowForm] = useState(false);
  const [newName, setNewName] = useState("");
  const [newCategory, setNewCategory] = useState("daily");

  const handleCreate = () => {
    const trimmed = newName.trim();
    if (!trimmed) return;
    onCreate(trimmed, newCategory, "");
    setNewName("");
    setShowForm(false);
  };

  return (
    <div className="template-section" data-testid="template-quick-add">
      <div className="template-header">
        <span className="template-label">Templates</span>
        <button
          className="template-add-btn"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? <X size={12} /> : <Plus size={12} />}
        </button>
      </div>

      {showForm && (
        <div className="template-create-form">
          <input
            className="template-create-input"
            placeholder="Template name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleCreate()}
            autoFocus
          />
          <div className="template-create-row">
            <div className="category-selector" style={{ marginBottom: 0 }}>
              {["daily", "weekly", "monthly"].map((cat) => (
                <button
                  key={cat}
                  className={`category-btn ${newCategory === cat ? `active-${cat}` : ""}`}
                  onClick={() => setNewCategory(cat)}
                  type="button"
                  style={{ fontSize: "0.6875rem", padding: "3px 8px" }}
                >
                  {cat.charAt(0).toUpperCase() + cat.slice(1)}
                </button>
              ))}
            </div>
          </div>
          <div className="template-create-row">
            <button className="template-create-btn" onClick={handleCreate}>Save</button>
            <button className="template-cancel-btn" onClick={() => setShowForm(false)}>Cancel</button>
          </div>
        </div>
      )}

      <div className="template-chips">
        {templates.length === 0 && !showForm && (
          <span className="template-empty">No templates yet</span>
        )}
        {templates.map((t) => (
          <div
            key={t.id}
            className="template-chip"
            onClick={() => onInstantiate(t.id)}
            title={`Click to add "${t.name}" as a task`}
          >
            <Plus size={10} />
            {t.name}
            <button
              className="template-chip-delete"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(t.id);
              }}
              title="Delete template"
            >
              <X size={8} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
